import { Component, Input, OnInit } from '@angular/core';
import { LeadsService } from '../../../../core/services/leads.service';
import { Uuid } from '../../../../../graphql';

interface Customer {
    ID_Customer: Uuid;
}

@Component({
    selector: 'app-clients-conversation-list',
    templateUrl: './clients-conversation-list.component.html',
    standalone: false,
})
export class ClientsConversationListComponent implements OnInit {
    @Input() customer?: Customer;
    leadIds: Uuid[] = [];

    constructor(private leadsService: LeadsService) {}

    ngOnInit(): void {
        if (this.customer) {
            this.leadsService.getLeadDetailsByCustomerId(this.customer.ID_Customer).subscribe((result) => {
                result.data.leadDetailsByCustomerId.map((lead) => {
                    this.leadIds.push(lead.iD_Lead);
                });
            });
        }
    }
}
